/**
 * Если часть DOM-элемента находится в области видимости, возвращает true. Иначе - false
 * @param el - DOM-element
 * @param viewPercent - число от 0 до 1, процент требуемой видимости блока
 */
import { getViewportHeight, getViewportWidth } from '../getViewportDimensions';

export const isElementInViewport = (el: HTMLElement, viewPercent: number = 0): boolean => {
  const rect = el.getBoundingClientRect();

  const windowHeight = getViewportHeight();
  const windowWidth = getViewportWidth();

  const vertBottomInView = rect.top - rect.height * viewPercent + rect.height >= 0;
  const vertTopInView = rect.top + rect.height * viewPercent <= windowHeight;
  const horLeftInView = rect.left + rect.width * viewPercent <= windowWidth;
  const horRightInView = rect.left - rect.width * viewPercent + rect.width >= 0;

  const elTop = window.pageYOffset + rect.top;
  const elBottom = window.pageYOffset + rect.bottom;
  const windowTop = window.pageYOffset;
  const windowBottom = window.pageYOffset + document.documentElement.clientHeight;
  /**
   * eсли позиция нижней части элемента больше позиции верхней части окна И
   * eсли позиция верхней части элемента меньше позиции нижней части окна - значит
   * элемент высокий и знаимает больше чем одна высота области просмотра
   */
  const elemMoreScreen = elBottom > windowTop && elTop < windowBottom;

  return (vertBottomInView && horRightInView && vertTopInView && horLeftInView) || elemMoreScreen;
};
